import { Bank, CalendarDots, MoneyWavy, UserList, CheckCircle, FileMagnifyingGlass, ShareFat } from '@phosphor-icons/react';
import React from 'react';
import Events from '../events/events';
import Payout from '../payout/payout';
import Organization from '../organization/organization';
import Select from '../../../components/select/select';

const menuItems = [
  { label: 'Events', 
    value: 'events',
    icon: <CalendarDots size={24} 
      weight="fill" 
    />, 
    content: <Events/> ,
  },
  { label: 'Payout',
    value: 'payout', 
    icon: <Bank size={24} />, 
    content: <Payout />,
  },
  { label: 'Organization', 
    value: 'organization',
    icon: <UserList size={24} 
    />, 
    content: <Organization/> ,
  },
];
const banner={
  icon:<MoneyWavy size={32} />,
  heading: 'Make sure you get paid!',
  content: 'Setup Payout method to receive payments.',
  cta:'Add payout',
  ctaLink:()=>handleMenuClick(menuItems[1]),
}
const event={  
  name: 'TakeMyTickets launch party',
  startTime: '10:00AM',
  endTime: '2:00PM',
  onShareClick: () => console.log('Share clicked'),
  onPreviewClick: () => console.log('Preview clicked'),
};

const headerContent = (
  <div className='event-content flex flex-col gap-2 border-b border-grey-10 pb-6'>
    <div className='heading-24'>{event.name}</div>
    <div className='text-16 flex gap-0.5 text-grey-70'>{event.startTime} to {event.endTime}</div>
    <div className='flex gap-2 py-1'>
      <Select
        icon={<ShareFat color="#101010" 
          size={20} />}
        label="Share"
        onClick={event.onShareClick}
        className='px-6 py-5'
        width={160}
      />
      <Select
        icon={<FileMagnifyingGlass color="#101010" 
          size={20} />}
        label="Preview"
        onClick={event.onPreviewClick}
        className='px-6 py-5'
        width={160}
      />
    </div>
  </div>
);


const checkItems=[
  {
    label: 'Event details',
    check:true,
    subItems: [
      { label: 'About', onClick: () => {}, isSelected: false , content:<div> hi there</div>},
      { label: 'When and where? ', onClick: () => {}, isSelected: false },
      { label: 'Image', onClick: () => {}, isSelected: false },
      { label: 'Event Description', onClick: () => {}, isSelected: false },
    ],
  },
  { label: 'Tickets', 
    check:true,
    content: <div>Content 1</div> ,
  },
  { label: 'Booking details', 
    check:true,
    content: <div>Content 2</div>,
  },
]
const tabs = ['Live', 'Under Review', 'Draft', 'Past'];

const faq = [
  {
    title:'When will I receive the payout?',
    content:'Your payout will be processed within 2-7 days after the event ends.',
  },
  {
    title:'Can I edit the payout details?',
    content:'Yes, you can edit payout details before your event goes live.',
  },
  {
    title:'Can I edit the payout details when event is live?',
    content:'No, once the event is live, payout details cannot be edited. We recommend setting up your payout details before going live.',
  },
  {
    title:'Can I get the money on demand?',
    content:'On-demand payouts are not available at the moment, but we’re working on introducing this feature soon.',
  },
]

export { 
  menuItems,
  banner,
  headerContent,
  checkItems,
  tabs,
  faq,
};
